import React from 'react';
import { Box, FormControl, InputLabel, Select, MenuItem, TextField, Button } from '@mui/material';

const InstructorSearchForm = ({
  state,
  setState,
  firstname,
  setFirstname,
  lastname,
  setLastname,
  phonenumber,
  setPhonenumber,
  submissionFilter,
  setSubmissionFilter,
  onSubmissionFilterChange,
  handleSearch,
  handleReset,
  states,
  handleFileChange,
  handleUpload,
  setCity,
  city,
  venueId,
  setVenueId,
}) => {

  return (
    <Box
      component="form"
      display="flex"
      alignItems="center"
      mb={3}
      onSubmit={(e) => {
        e.preventDefault();
        handleSearch();
      }}
    >

      <FormControl variant="outlined" sx={{ minWidth: 100, mr: 2 }}>
        <InputLabel>State</InputLabel>
        <Select value={state} onChange={(e) => setState(e.target.value)} label="State">
                <MenuItem value=""><em>Please Select</em></MenuItem>
                {states.map((st) => (
                  <MenuItem key={st} value={st}>{st}</MenuItem>
                ))}
              </Select>
      </FormControl>
      <TextField
        variant="outlined"
        label="City"
        value={city}
        onChange={(e) => setCity(e.target.value)}
        sx={{ minWidth: 50, mr: 2 }}
      />
      <TextField
        variant="outlined"
        label="Venue ID"
        value={venueId ?? ''}
        onChange={(e) => setVenueId(e.target.value)}
        sx={{ minWidth: 50, mr: 2 }}
      />
      <TextField
        variant="outlined"
        label="First Name"
        value={firstname}
        onChange={(e) => setFirstname(e.target.value)}
        sx={{ minWidth: 50, mr: 2 }}
      />
      <TextField
        variant="outlined"
        label="Last Name"
        value={lastname}
        onChange={(e) => setLastname(e.target.value)}
        sx={{ minWidth: 50, mr: 2 }}
      />
      <TextField
        variant="outlined"
        label="phoneNumber"
        value={phonenumber}
        onChange={(e) => setPhonenumber(e.target.value)}
        sx={{ minWidth: 50, mr: 2 }}
      />
      <FormControl variant="outlined" sx={{ minWidth: 120, mr: 2 }}>
        <InputLabel>Submitted</InputLabel>
        <Select
          value={submissionFilter}
          onChange={(e) => {
            const value = e.target.value;
            setSubmissionFilter(value);
            onSubmissionFilterChange?.(value);
          }}
          label="Submitted"
        >
          <MenuItem value="ALL">All</MenuItem>
          <MenuItem value="YES">YES</MenuItem>
          <MenuItem value="NO">NO</MenuItem>
          <MenuItem value="EXPIRED">Expired</MenuItem>
        </Select>
      </FormControl>
      <Button
        type="submit"
        variant="contained"
        color="primary"
        sx={{ mr: 2 }}
      >
        Search
      </Button>
      <Button variant="outlined" onClick={handleReset} sx={{mr:15}}>
        Reset
      </Button>

      <input
      accept=".xlsx, .xls"
      type="file"
      onChange={(e)=>{handleFileChange(e);
          handleUpload();
      }}
      style={{ display: 'none' }}
      id="upload-file"
    />
    {/* <label htmlFor="upload-file">
      <Button variant="outlined" component="span" sx={{ mr: 2 }}>
        Upload
      </Button>
    </label>
      <Button variant='outlined'onClick={handleExport}>
        Export
      </Button> */}
      <Box sx={{ flexGrow: 1 }} />
    </Box>
  );
};

export default InstructorSearchForm;


